import { Type } from "./Type";

export const ObjectEx = {
    isEmpty: (obj: any): boolean => {
        if (!obj)
            return true;
        for (const o in obj) {
            if (obj.hasOwnProperty(o))
                return false;
        }
        return true;
    },

    equals: (object1: any, object2: any): boolean => {
        if (!object1 && !object2)
            return true;
        else if ((!object1 && object2) || (object1 && !object2))
            return false;
        else {
            const keys1 = Object.keys(object1);
            const keys2 = Object.keys(object2);

            if (keys1.length !== keys2.length)
                return false;

            for (const key of keys1) {
                if (object1[key] !== object2[key]) {
                    return false;
                }
            }
            return true;
        }
    },

    clone<T>(data: T): T {
        let copy: any;

        if (Type.isPrimitive(data))
            return data;
        if (data instanceof Date) {
            copy = new Date(data.getTime());
            return copy;
        }
        if (data instanceof Set) {
            copy = new Set();
            for (const item of data as Array<any>)
                copy.add(item);
            return copy;
        }

        if (data instanceof Map) {
            copy = new Map();
            const keys = Object.keys(data);
            for (const key of keys) {
                copy.set(key, ObjectEx.clone(data.get(key)));
            }
            return copy;
        }

        copy = Array.isArray(data) ? [] : {};
        for (const key in data)
            copy[key] = ObjectEx.clone(data[key]);
        return copy;
    }
}
